import Vue from 'vue'
import ElementUI from 'element-ui';//引入element-ui
import 'element-ui/lib/theme-chalk/index.css';//css需要单独引入
//import './styles/element-variables.scss'
import App from './App.vue'
import router from './router'
import './assets/css/reset.css'
import './assets/css/iconfont.css'
import http from './api/http'
import './utils/localStorage' //把本地存储赋值给store
import i18n from './lang/index'
import './router/permission'
import VueDND from 'awe-dnd'
import FileSaver from 'file-saver'
//import * as XLSX from 'xlsx'
import AuthUtil from '@/utils/auth'

// 演示版主机检测逻辑
function checkDemoHost() {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  
  // 允许的主机名：localhost, 127.0.0.1, 以及 file 协议（本地文件）
  const allowedHosts = ['localhost', '127.0.0.1', '0.0.0.0'];
  const allowedDomains = ['xxjxkh.com', 'newfly.top'];
  
  if (protocol === 'file:') {
    return true; // 本地文件方式打开允许
  }
  
  // 检查是否是完全匹配的允许主机
  if (allowedHosts.includes(hostname)) {
    return true;
  }
  
  // 检查是否是允许域名的子域名或主域名
  for (const domain of allowedDomains) {
    // 主域名匹配 (xxjxkh.com)
    if (hostname === domain) {
      return true;
    }
    // 子域名匹配 (*.xxjxkh.com)
    if (hostname.endsWith('.' + domain)) {
      return true;
    }
  }
  
  // 如果不是允许的主机，显示错误信息并阻止应用继续运行
  document.body.innerHTML = `
    <div style="display: flex; justify-content: center; align-items: center; height: 100vh; background-color: #f5f5f5; font-family: Arial, sans-serif;">
      <div style="text-align: center; padding: 20px; background-color: white; border-radius: 8px; box-shadow: 0 2px 10px rgba(0,0,0,0.1);">
        <h2 style="color: #f56565; margin-bottom: 16px;">演示版访问限制</h2>
        <p style="color: #666; margin-bottom: 16px;">此系统为演示版本，仅限本机及授权域名访问。</p>
        <p style="color: #666; margin-bottom: 16px;">请使用以下地址访问：</p>
        <ul style="color: #4a5568; margin-bottom: 16px; text-align: left;">
          <li>http://localhost:9988</li>
          <li>http://127.0.0.1:9988</li>
          <li>https://xxjxkh.com 或其子域名</li>
          <li>https://newfly.top 或其子域名</li>
        </ul>
        <p style="color: #666; font-size: 12px;">当前访问地址: ${window.location.hostname}</p>
      </div>
    </div>
  `;
  return false;
}

// 执行主机检测
if (!checkDemoHost()) {
  // 如果检测失败，不继续初始化 Vue 应用
  throw new Error('Demo version can only run on localhost');
}

Vue.prototype.$auth = AuthUtil
Vue.prototype.$http=http
Vue.prototype.$FileSaver = FileSaver; //设置全局
//Vue.prototype.$XLSX = XLSX; //设置全
Vue.use(ElementUI);//使用引入的elementui
Vue.use(VueDND)
Vue.config.productionTip = false
Vue.filter('formatDate', function(value) {
  if (!value) return '';
  const date = new Date(value);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  return `${year}-${month}`;
});
new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app')